import {
  AssignmentConfig,
  EmptyAssignment,
} from "@/types/models/Assignment.interface";

interface Assignment {
  assignment_config: AssignmentConfig;
}

const getAssignmentSetting = (
  configKey: keyof AssignmentConfig,
  assignment: Assignment | EmptyAssignment | null | undefined,
) => {
  return assignment?.assignment_config?.[configKey] || false;
};

export default getAssignmentSetting;
